import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VendorContainerComponent } from './vendor-container/vendor-container.component';
import { VendorPresenterComponent } from './vendor-presenter/vendor-presenter.component';
import { SharedModule } from '../shared/shared.module';
import { UIRouterModule } from '@uirouter/angular';
import { VendorRoute } from './vendor.route';

@NgModule({
    declarations: [VendorContainerComponent, VendorPresenterComponent],
    imports: [
        CommonModule,
        SharedModule,
        UIRouterModule.forChild({
            states: [VendorRoute]
        })
    ]
})
export class VendorModule {}
